import { render, staticRenderFns } from "./shareComponent.vue?vue&type=template&id=c6f2d4de&scoped=true&"
import script from "./shareComponent.vue?vue&type=script&lang=js&"
export * from "./shareComponent.vue?vue&type=script&lang=js&"
import style0 from "./shareComponent.vue?vue&type=style&index=0&id=c6f2d4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f2d4de",
  null
  
)

export default component.exports